import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import * as React from 'react';

import { NoImage } from 'shared/components/NoImage';
import { ISimilarNewObjectEntitySchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './index.css';
import { LinkWrapper } from '../../../common/components/link_wrapper';
import { isArrayWithItems } from '../../../utils';
import { CurrencySymbol } from '../../../utils/formatters';
import { IconsMetro } from '../../similar_offers/icons/IconsMetro';

interface ISimilarNewObjectsItemProps {
  item: ISimilarNewObjectEntitySchema;
  position: number;
  onClick(offer: ISimilarNewObjectEntitySchema, position: number): void;
}

const MAX_ADDRESS_LENGTH = 40;

export class SimilarNewObjectsItem extends React.PureComponent<ISimilarNewObjectsItemProps, {}> {
  public render() {
    const { item } = this.props;

    return (
      <li className={styles['container']}>
        {this.renderPhoto()}
        {this.renderTitle()}
        {this.renderParentName()}
        {this.renderAddress()}
        {this.renderUnderground()}
        {item.priceRur && (
          <strong className={styles['price']}>
            {numberToPrettyString(Number(item.priceRur))} {CurrencySymbol.Rur}
          </strong>
        )}
      </li>
    );
  }

  private renderPhoto() {
    const { item } = this.props;

    let photo = (
      <div className={styles['no-photo']}>
        <NoImage />
      </div>
    );

    if (item.photoUrl) {
      photo = <img className={styles['photo']} src={item.photoUrl} alt={item.newobjectName || ''} />;
    }

    return (
      <LinkWrapper href={item.id ? `/sale/flat/${item.id}` : ''} onClick={this.handleClickOnOfferLink} target="_blank">
        {photo}
      </LinkWrapper>
    );
  }

  private renderTitle() {
    const { item } = this.props;

    if (!item.roomTitle) {
      return null;
    }

    const title: Array<string> = [item.roomTitle];

    const area: Array<string | null> = [
      numberToPrettyString(Number(item.totalArea)),
      numberToPrettyString(Number(item.livingArea)),
      numberToPrettyString(Number(item.kitchenArea)),
    ].filter(Boolean);

    if (isArrayWithItems<number>(area)) {
      title.push(area.join('/').concat('\u00A0кв.м.'));
    }

    const floor: Array<number | null> = [item.floor, item.floorn].filter(Boolean);

    if (isArrayWithItems<number>(floor)) {
      title.push(`этаж\u00A0${floor.join('/')}`);
    }

    return (
      <LinkWrapper href={item.id ? `/sale/flat/${item.id}` : ''} onClick={this.handleClickOnOfferLink} target="_blank">
        <h4 className={styles['title']}>{title.join(', ')}</h4>
      </LinkWrapper>
    );
  }

  private renderParentName() {
    const { item } = this.props;

    if (!item.newobjectName) {
      return null;
    }

    return (
      <LinkWrapper href={item.newobjectUrl || ''} target="_blank">
        <h3 className={styles['parent-name']}>ЖК «{item.newobjectName}»</h3>
      </LinkWrapper>
    );
  }

  private renderAddress() {
    const { item } = this.props;

    let { addressStr } = item;

    if (!addressStr) {
      return null;
    }

    if (addressStr.length > MAX_ADDRESS_LENGTH) {
      addressStr = addressStr.substr(0, MAX_ADDRESS_LENGTH).concat('...');
    }

    return <div>{addressStr}</div>;
  }

  private renderUnderground() {
    const { undergroundInfo } = this.props.item;

    if (!undergroundInfo || !undergroundInfo.name || !undergroundInfo.type || !undergroundInfo.lineColor) {
      return null;
    }

    return (
      <div className={styles['underground']}>
        <IconsMetro color={undergroundInfo.lineColor} type={undergroundInfo.type} />
        {undergroundInfo.name}
      </div>
    );
  }

  private handleClickOnOfferLink = () => {
    this.props.onClick(this.props.item, this.props.position);
  };
}
